import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import DateRangePicker from 'reporting-ui-components/components/shared/DateRangePicker';
// @ts-expect-error Untyped module
import { HISTORICAL_RANGE_TYPES } from 'reporting-ui-components/components/shared/constants/DateRangeConstants';
import * as Frequency from 'reporting-data/constants/frequency';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { useReportingFiltersProvider } from '../../providers/ReportingFiltersProvider';
import useUsageTrackerProps from '../../hooks/useUsageTrackerProps';
import { DETAILS_INTERACTION } from '../../constants/trackerEvents';
import { Select } from 'foundations-components/components/Select';
import { Select as TransitionalSelect } from 'foundations-components/transitional/components/Select';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { useAuthInfoProvider } from 'content-management-data-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RANGE_TYPE_OPTIONS = Object.keys(HISTORICAL_RANGE_TYPES);
const FrequencySelector = ({
  frequency,
  updateFrequency,
  isUngatedForCMPTrellisMigration
}) => {
  const options = [{
    text: I18n.text('content-management-details-lib.reporting.filters.frequencyOption.day'),
    value: Frequency.DAY
  }, {
    text: I18n.text('content-management-details-lib.reporting.filters.frequencyOption.week'),
    value: Frequency.WEEK
  }, {
    text: I18n.text('content-management-details-lib.reporting.filters.frequencyOption.month'),
    value: Frequency.MONTH
  }];
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-details-lib.reporting.filters.frequencyInputLabel"
    }),
    children: isUngatedForCMPTrellisMigration ? /*#__PURE__*/_jsx(Select, {
      onSelectedOptionChange: ({
        value
      }) => updateFrequency(value),
      options: options,
      selectedValues: [frequency]
    }) : /*#__PURE__*/_jsx(TransitionalSelect, {
      buttonUse: "transparent",
      padding: "0",
      marginInlineEnd: "300",
      onChange: event => updateFrequency(event.target.value),
      options: options,
      value: frequency
    })
  });
};
const ReportingFilters = ({
  additionalReportingFilters,
  currentDateRange,
  currentFrequency,
  onDateRangeChange,
  onFrequencyChange
}) => {
  const {
    dateRange: providerDateRange,
    frequency: providerFrequency,
    handleDateRangeChange,
    setFrequency
  } = useReportingFiltersProvider();
  const {
    tracker
  } = useUsageTrackerProps();
  const {
    getIsUngatedForCMPTrellisMigration
  } = useAuthInfoProvider();
  const isUngatedForCMPTrellisMigration = getIsUngatedForCMPTrellisMigration();
  const updateDateRange = useCallback(updatedDateRange => {
    if (onDateRangeChange) {
      onDateRangeChange(updatedDateRange);
    } else {
      handleDateRangeChange(updatedDateRange);
    }
    tracker.track(DETAILS_INTERACTION, {
      action: 'changed-reporting-date-range-filter'
    });
  }, [tracker, handleDateRangeChange, onDateRangeChange]);
  const updateFrequency = useCallback(updatedFrequency => {
    if (onFrequencyChange) {
      onFrequencyChange(updatedFrequency);
    } else {
      setFrequency(updatedFrequency);
    }
    tracker.track(DETAILS_INTERACTION, {
      action: 'changed-reporting-frequency-filter'
    });
  }, [tracker, setFrequency, onFrequencyChange]);
  const effectiveDateRange = currentDateRange || providerDateRange;
  const effectiveFrequency = currentFrequency || providerFrequency;
  return /*#__PURE__*/_jsx(ToolBar, {
    marginBlockStart: "0",
    "data-test-id": "reporting-filter-bar",
    use: "filter-bar",
    children: /*#__PURE__*/_jsxs(ToolBarGroup, {
      "data-test-id": "reporting-filter-bar-group",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.reporting.filters.dateRangeInputLabel"
      }), /*#__PURE__*/_jsx(DateRangePicker, {
        buttonUse: isUngatedForCMPTrellisMigration ? 'form' : undefined,
        endDate: effectiveDateRange.endDate,
        entireCurrentUnit: effectiveDateRange.entireCurrentUnit,
        format: "YYYYMMDD",
        hideEntireCurrentUnit: true,
        onChange: updateDateRange,
        rangeType: effectiveDateRange.rangeType,
        rangeTypeOptions: RANGE_TYPE_OPTIONS,
        rollingDays: effectiveDateRange.rollingDays,
        startDate: effectiveDateRange.startDate
      }), /*#__PURE__*/_jsx(FrequencySelector, {
        frequency: effectiveFrequency,
        updateFrequency: updateFrequency,
        isUngatedForCMPTrellisMigration: isUngatedForCMPTrellisMigration
      }), additionalReportingFilters && additionalReportingFilters.map((Filter, index) => /*#__PURE__*/_jsx(Filter, {}, `reporting-filter-${index}`))]
    })
  });
};
export default ReportingFilters;